<h1 class="text-white text-lg font-semibold mb-4">Reportes</h1>
<div class="p-4 bg-gray-800 rounded-md shadow-md">
    <h2 class="text-white text-base font-semibold mb-4">Reporte por descuento</h2>
    <form [formGroup]="reportForm" (ngSubmit)="onGenerateReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="reportForm.get('grouping')?.value && reportForm.get('grouping')?.value !== 'week'
                ? 'md:grid-cols-[1fr_1fr_1fr_1fr_1fr_auto]'
                : 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]'">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Descuento</mat-label>
            <mat-select formControlName="discountId">
                <mat-option *ngFor="let discount of discounts" [value]="discount.id">
                    {{ discount.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="reportForm.get('discountId')?.invalid && (reportForm.get('discountId')?.dirty || reportForm.get('discountId')?.touched)">
                <span>El descuento es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of groupingOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="reportForm.get('grouping')?.invalid && (reportForm.get('grouping')?.dirty || reportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>
        <div *ngIf="reportForm.get('grouping')?.value && reportForm.get('grouping')?.value !== 'week'">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(reportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="discountFilterIds" (valueChange)="onDiscountFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(discountFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllDiscountFiltersSelected()" (change)="($event.checked ? selectAllDiscountFilters() : clearDiscountFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredDiscountFilterOptions" [value]="getFilterOptionValue(option, reportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, reportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="startPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="startPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="startPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="reportForm.get('startDate')?.invalid && (reportForm.get('startDate')?.dirty || reportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="endPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="endPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="endPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="reportForm.get('endDate')?.invalid && (reportForm.get('endDate')?.dirty || reportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="reportForm.errors?.['dateRangeInvalid'] && (reportForm.get('endDate')?.dirty || reportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
        </mat-form-field>
        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingDiscount">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Reporte de depósitos</h2>
    <form [formGroup]="depositReportForm" (ngSubmit)="onGenerateDepositReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="depositReportForm.get('grouping')?.value && depositReportForm.get('grouping')?.value !== 'week'
                ? 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]'
                : 'md:grid-cols-[1fr_1fr_1fr_auto]'">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of groupingOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="depositReportForm.get('grouping')?.invalid && (depositReportForm.get('grouping')?.dirty || depositReportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>
        <div *ngIf="depositReportForm.get('grouping')?.value && depositReportForm.get('grouping')?.value !== 'week'">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(depositReportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="depositFilterIds" (valueChange)="onDepositFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(depositFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllDepositFiltersSelected()" (change)="($event.checked ? selectAllDepositFilters() : clearDepositFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredDepositFilterOptions" [value]="getFilterOptionValue(option, depositReportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, depositReportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="depositStartPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="depositStartPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="depositStartPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #depositStartPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="depositReportForm.get('startDate')?.invalid && (depositReportForm.get('startDate')?.dirty || depositReportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="depositEndPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="depositEndPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="depositEndPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #depositEndPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="depositReportForm.get('endDate')?.invalid && (depositReportForm.get('endDate')?.dirty || depositReportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="depositReportForm.errors?.['dateRangeInvalid'] && (depositReportForm.get('endDate')?.dirty || depositReportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
        </mat-form-field>
        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingDeposit">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Reporte pago de liquidación</h2>
    <form [formGroup]="paymentReportForm" (ngSubmit)="onGenerateLiquidationPaymentReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="paymentReportForm.get('grouping')?.value && paymentReportForm.get('grouping')?.value !== 'week'
                ? 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]'
                : 'md:grid-cols-[1fr_1fr_1fr_auto]'">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of groupingOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentReportForm.get('grouping')?.invalid && (paymentReportForm.get('grouping')?.dirty || paymentReportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>
        <div *ngIf="paymentReportForm.get('grouping')?.value && paymentReportForm.get('grouping')?.value !== 'week'">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(paymentReportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="paymentFilterIds" (valueChange)="onPaymentFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(paymentFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllPaymentFiltersSelected()" (change)="($event.checked ? selectAllPaymentFilters() : clearPaymentFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredPaymentFilterOptions" [value]="getFilterOptionValue(option, paymentReportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, paymentReportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="paymentStartPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="paymentStartPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="paymentStartPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #paymentStartPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="paymentReportForm.get('startDate')?.invalid && (paymentReportForm.get('startDate')?.dirty || paymentReportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="paymentEndPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="paymentEndPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="paymentEndPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #paymentEndPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="paymentReportForm.get('endDate')?.invalid && (paymentReportForm.get('endDate')?.dirty || paymentReportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="paymentReportForm.errors?.['dateRangeInvalid'] && (paymentReportForm.get('endDate')?.dirty || paymentReportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
        </mat-form-field>
        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingPayment">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Documentos Faltantes</h2>
    <form [formGroup]="missingDocumentsReportForm" (ngSubmit)="onGenerateMissingDocumentsReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="missingDocumentsReportForm.get('grouping')?.value && missingDocumentsReportForm.get('grouping')?.value !== 'week'
                ? 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]'
                : 'md:grid-cols-[1fr_1fr_1fr_auto]'">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of groupingOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="missingDocumentsReportForm.get('grouping')?.invalid && (missingDocumentsReportForm.get('grouping')?.dirty || missingDocumentsReportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>
        <div *ngIf="missingDocumentsReportForm.get('grouping')?.value && missingDocumentsReportForm.get('grouping')?.value !== 'week'">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(missingDocumentsReportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="missingDocumentsFilterIds" (valueChange)="onMissingDocumentsFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(missingDocumentsFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllMissingDocumentsFiltersSelected()" (change)="($event.checked ? selectAllMissingDocumentsFilters() : clearMissingDocumentsFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredMissingDocumentsFilterOptions" [value]="getFilterOptionValue(option, missingDocumentsReportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, missingDocumentsReportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="missingDocumentsStartPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="missingDocumentsStartPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="missingDocumentsStartPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #missingDocumentsStartPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="missingDocumentsReportForm.get('startDate')?.invalid && (missingDocumentsReportForm.get('startDate')?.dirty || missingDocumentsReportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="missingDocumentsEndPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="missingDocumentsEndPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="missingDocumentsEndPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #missingDocumentsEndPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="missingDocumentsReportForm.get('endDate')?.invalid && (missingDocumentsReportForm.get('endDate')?.dirty || missingDocumentsReportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="missingDocumentsReportForm.errors?.['dateRangeInvalid'] && (missingDocumentsReportForm.get('endDate')?.dirty || missingDocumentsReportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
        </mat-form-field>
        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingMissingDocuments">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Reporte Clientes</h2>
    <form [formGroup]="catalogReportForm" (ngSubmit)="onGenerateCatalogReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="catalogReportForm.get('grouping')?.value
                ? (catalogReportForm.get('reportType')?.value === 'nit'
                    ? 'md:grid-cols-[1fr_1fr_1fr_auto]'
                    : 'md:grid-cols-[1fr_1fr_1fr_1fr_1fr_auto]')
                : (catalogReportForm.get('reportType')?.value === 'nit'
                    ? 'md:grid-cols-[1fr_1fr_auto]'
                    : 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]')">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Tipo de reporte</mat-label>
            <mat-select formControlName="reportType">
                <mat-option *ngFor="let option of catalogReportOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="catalogReportForm.get('reportType')?.invalid && (catalogReportForm.get('reportType')?.dirty || catalogReportForm.get('reportType')?.touched)">
                <span>El tipo de reporte es requerido.</span>
            </mat-error>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of getCatalogGroupingOptions()" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="catalogReportForm.get('grouping')?.invalid && (catalogReportForm.get('grouping')?.dirty || catalogReportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>

        <div *ngIf="catalogReportForm.get('grouping')?.value">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(catalogReportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="catalogFilterIds" (valueChange)="onCatalogFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(catalogFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllCatalogFiltersSelected()" (change)="($event.checked ? selectAllCatalogFilters() : clearCatalogFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredCatalogFilterOptions" [value]="getFilterOptionValue(option, catalogReportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, catalogReportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field *ngIf="catalogReportForm.get('reportType')?.value !== 'nit'" floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="catalogStartPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="catalogStartPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="catalogStartPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #catalogStartPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="catalogReportForm.get('startDate')?.invalid && (catalogReportForm.get('startDate')?.dirty || catalogReportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="catalogReportForm.get('reportType')?.value !== 'nit'" floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="catalogEndPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="catalogEndPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="catalogEndPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #catalogEndPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="catalogReportForm.get('endDate')?.invalid && (catalogReportForm.get('endDate')?.dirty || catalogReportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="catalogReportForm.errors?.['dateRangeInvalid'] && (catalogReportForm.get('endDate')?.dirty || catalogReportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
            <mat-error *ngIf="catalogReportForm.errors?.['datesRequired'] && !(catalogReportForm.get('startDate')?.hasError('required') || catalogReportForm.get('endDate')?.hasError('required')) && (catalogReportForm.get('startDate')?.dirty || catalogReportForm.get('startDate')?.touched || catalogReportForm.get('endDate')?.dirty || catalogReportForm.get('endDate')?.touched)">
                <span>Debes ingresar fecha inicio y fecha fin, o dejar ambas vacías.</span>
            </mat-error>
        </mat-form-field>

        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingCatalog">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Reporte Autobus</h2>
    <form [formGroup]="busLifecycleReportForm" (ngSubmit)="onGenerateBusLifecycleReport()">
        <div class="grid grid-cols-1 gap-4"
             [ngClass]="busLifecycleReportForm.get('grouping')?.value
                ? 'md:grid-cols-[1fr_1fr_1fr_1fr_1fr_auto]'
                : 'md:grid-cols-[1fr_1fr_1fr_1fr_auto]'">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Tipo de reporte</mat-label>
            <mat-select formControlName="reportType">
                <mat-option *ngFor="let option of busLifecycleReportOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="busLifecycleReportForm.get('reportType')?.invalid && (busLifecycleReportForm.get('reportType')?.dirty || busLifecycleReportForm.get('reportType')?.touched)">
                <span>El tipo de reporte es requerido.</span>
            </mat-error>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Agrupación</mat-label>
            <mat-select formControlName="grouping">
                <mat-option *ngFor="let option of busLifecycleGroupingOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="busLifecycleReportForm.get('grouping')?.invalid && (busLifecycleReportForm.get('grouping')?.dirty || busLifecycleReportForm.get('grouping')?.touched)">
                <span>La agrupación es requerida.</span>
            </mat-error>
        </mat-form-field>

        <div *ngIf="busLifecycleReportForm.get('grouping')?.value">
            <mat-form-field floatLabel="always" class="w-full border-0">
                <mat-label class="text-gray text-lg">Filtrar por {{ getFilterLabel(busLifecycleReportForm.get('grouping')?.value) }}</mat-label>
                <mat-select multiple [value]="busLifecycleFilterIds" (valueChange)="onBusLifecycleFilterSelectionChange($event)">
                    <mat-select-trigger>{{ getSelectionCountLabel(busLifecycleFilterIds) }}</mat-select-trigger>
                    <div class="px-3 py-2 flex items-center gap-2 border-b border-gray-700" (click)="$event.stopPropagation()">
                        <mat-checkbox [checked]="isAllBusLifecycleFiltersSelected()" (change)="($event.checked ? selectAllBusLifecycleFilters() : clearBusLifecycleFilters())">Seleccionar todos</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let option of filteredBusLifecycleFilterOptions" [value]="getFilterOptionValue(option, busLifecycleReportForm.get('grouping')?.value)">
                        {{ getFilterOptionLabel(option, busLifecycleReportForm.get('grouping')?.value) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha inicio</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="busLifecycleStartPicker" formControlName="startDate" class="text-lg text-white bg-blue-primary" readonly (click)="busLifecycleStartPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="busLifecycleStartPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #busLifecycleStartPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="busLifecycleReportForm.get('startDate')?.invalid && (busLifecycleReportForm.get('startDate')?.dirty || busLifecycleReportForm.get('startDate')?.touched)">
                <span>La fecha de inicio es requerida.</span>
            </mat-error>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Fecha fin</mat-label>
            <div class="relative">
                <input matInput [matDatepicker]="busLifecycleEndPicker" formControlName="endDate" class="text-lg text-white bg-blue-primary" readonly (click)="busLifecycleEndPicker.open()">
                <mat-datepicker-toggle matSuffix [for]="busLifecycleEndPicker" class="datepicker-toggle right-0"></mat-datepicker-toggle>
                <mat-datepicker #busLifecycleEndPicker></mat-datepicker>
            </div>
            <mat-error *ngIf="busLifecycleReportForm.get('endDate')?.invalid && (busLifecycleReportForm.get('endDate')?.dirty || busLifecycleReportForm.get('endDate')?.touched)">
                <span>La fecha de fin es requerida.</span>
            </mat-error>
            <mat-error *ngIf="busLifecycleReportForm.errors?.['dateRangeInvalid'] && (busLifecycleReportForm.get('endDate')?.dirty || busLifecycleReportForm.get('endDate')?.touched)">
                <span>La fecha de fin debe ser mayor o igual a la fecha de inicio.</span>
            </mat-error>
            <mat-error *ngIf="busLifecycleReportForm.errors?.['datesRequired'] && !(busLifecycleReportForm.get('startDate')?.hasError('required') || busLifecycleReportForm.get('endDate')?.hasError('required')) && (busLifecycleReportForm.get('startDate')?.dirty || busLifecycleReportForm.get('startDate')?.touched || busLifecycleReportForm.get('endDate')?.dirty || busLifecycleReportForm.get('endDate')?.touched)">
                <span>Debes ingresar fecha inicio y fecha fin, o dejar ambas vacías.</span>
            </mat-error>
        </mat-form-field>

        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingBusLifecycle">Generar Excel</button>
        </div>
        </div>
    </form>
</div>

<div class="p-4 bg-gray-800 rounded-md shadow-md mt-6">
    <h2 class="text-white text-base font-semibold mb-4">Estado de Cuenta por Ruta</h2>
    <form [formGroup]="routeAccountStatementReportForm" (ngSubmit)="onGenerateRouteAccountStatementReport()">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-[1fr_1fr_auto]">
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Ruta</mat-label>
            <mat-select formControlName="routeId">
                <mat-option value="all">Todas las rutas</mat-option>
                <mat-option *ngFor="let route of routes" [value]="route.id">
                    {{ route.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="routeAccountStatementReportForm.get('routeId')?.invalid && (routeAccountStatementReportForm.get('routeId')?.dirty || routeAccountStatementReportForm.get('routeId')?.touched)">
                <span>La ruta es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full border-0">
            <mat-label class="text-gray text-lg">Año</mat-label>
            <mat-select formControlName="year">
                <mat-option *ngFor="let year of routeAccountStatementYears" [value]="year">
                    {{ year }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="routeAccountStatementReportForm.get('year')?.invalid && (routeAccountStatementReportForm.get('year')?.dirty || routeAccountStatementReportForm.get('year')?.touched)">
                <span>El año es requerido.</span>
            </mat-error>
        </mat-form-field>
        <div class="self-end flex items-end">
            <button matButton type="submit" [disabled]="isSubmittingRouteAccountStatement">Generar Excel</button>
        </div>
        </div>
    </form>
</div>
